<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="seqno"
      :border="false"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="500"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="{ highlight: true, trigger: 'row', reserve: true }"
      @radio-change="radioChange"
    >
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:contactFlag="{ row }">
        <el-tag
          size="mini"
          :type="row.contactDefaultFlagText === '是' ? 'success' : 'danger'"
        >
          {{ row.contactDefaultFlagText }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  methods: {
    radioChange({ row }) {
      this.$emit('radio-change', row)
    },
  },
}
</script>
